<template>
    <div id="canvas">
        <v-chart :options="option"></v-chart>
    </div>
</template>
<script>
import echarts from 'echarts'
import {showWork,Config} from './dataBar'
    let this_=this;
export default {
    props:{
        canvasList:{
            type:Array,
            default:()=>[]
        }
    },
    data(){
        return{
            option:Config.barOptions
        }
    },
    created(){
        this.getData();
    },
    methods:{
        getData(){
            let obj = {};
            let subjectList = [];
            let collectCount = [];
            let praiseCount = [];
            let resCount = [];
            this.canvasList.forEach((item)=>{
                subjectList.push(item.subjectName);
                collectCount.push(item.collectCount);
                praiseCount.push(item.praiseCount);
                resCount.push(item.resCount);
            })
            obj.subjectList=subjectList;
            obj.collectCount=collectCount;
            obj.praiseCount=praiseCount;
            obj.resCount=resCount;
            showWork(obj);
        }
    }
}
</script>
<style lang="less" scoped>
#canvas{
    width:100%;
    height: 100%;
}
/deep/ .echarts{
    width:100%;
    height: 100%;
}
</style>